export default __webpack_public_path__ + "static/media/verify-email-success.309d7aff.svg";